const ParagraphEditor = ({ paragraphs, onChange, onAdd, onRemove }) => {
    return (
        <div className="content-paragraph-editor">
            <div className="content-paragraph-head">
                <span>Paragraphs</span>
                <button type="button" className="content-link-btn" onClick={onAdd}>
                    Add paragraph
                </button>
            </div>

            {paragraphs.map((item, index) => (
                <article key={item.id} className="content-paragraph-row">
                    <label htmlFor={`paragraph-${item.id}`}>Paragraph {index + 1}</label>
                    <textarea
                        id={`paragraph-${item.id}`}
                        value={item.paragraph}
                        onChange={(event) => onChange(item.id, event.target.value)}
                        rows={4}
                        placeholder="Type a reading paragraph..."
                    />
                    <button
                        type="button"
                        className="content-link-btn danger"
                        onClick={() => onRemove(item.id)}
                        disabled={paragraphs.length === 1}
                    >
                        Remove
                    </button>
                </article>
            ))}
        </div>
    );
};

export default ParagraphEditor;
